import template from './historyEntryTitle.html';

export const historyEntryTitleComponent = {
  name: 'historyComponent',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    name: '<',
    count: '<',
    time: '<'
  }
};
